export enum ProgressScreeningRequestStatusRequestNoEnum {
  actionItem1 = 1,
  actionItem2 = 2,
  actionItem3 = 3,
}

export enum ProgressScreeningRequestStatusRequestStatusEnum {
  notInformedYet = 0,
  notHandledYet = 1,
  completed = 2,
}
